export default __webpack_public_path__ + "static/media/ic_arrow_select.bcc09a52.svg";